import { Exclude, Expose, Type } from 'class-transformer';
import { AccountDTO, AccountType } from './account.dto';
import { CustomerDTO } from './customer.dto';
import { DeviceDTO } from './device.dto';
import { PlanDTO } from './plan.dto';
import { WorkspaceDTO } from './workspace.dto';
import { SocialSetDTO } from './social-set.dto';

@Exclude()
export class UserDTO {
  @Expose()
  id: number;

  @Expose()
  email: string;

  @Expose()
  firstName: string;

  @Expose()
  lastName: string;

  @Expose()
  timezone: string;

  @Expose()
  memberCount: number;

  @Expose()
  workspaceMemberCount: number;

  @Expose()
  acceptedAI: boolean;

  @Expose()
  AIRequestsAvailable: boolean;

  @Expose()
  @Type(() => AccountDTO)
  accounts: AccountDTO[];

  @Expose()
  @Type(() => WorkspaceDTO)
  workspaces: WorkspaceDTO[];

  @Expose()
  @Type(() => SocialSetDTO)
  socialSets: SocialSetDTO[];

  @Expose()
  @Type(() => PlanDTO)
  plan: PlanDTO;

  @Expose()
  pinterestTrialEnabled: boolean;

  @Expose()
  @Type(() => CustomerDTO)
  customer: CustomerDTO;

  @Expose()
  enabled: boolean;

  @Expose()
  devices: DeviceDTO[];

  @Expose()
  planolyVersion: number;

  get getPinterestAccounts() {
    return this.accounts ? this.accounts.filter((acct) => acct.type === AccountType.PINTEREST) : null;
  }

  get isFree(): boolean {
    return this.plan.isFree();
  }

  get isPlanoly2User(): boolean {
    return this.planolyVersion === 2;
  }

  get activeWorkspace(): WorkspaceDTO {
    let activeWorkspace = this.workspaces ? this.workspaces.find((workspace) => workspace.isActive) : null;
    if (!activeWorkspace && this?.workspaces.length) {
      activeWorkspace = this.workspaces[0];
    }
    return activeWorkspace;
  }

  get activeSocialSet(): SocialSetDTO {
    return this.socialSets ? this.socialSets.find((ss) => ss.workspace?.isActive) : null;
  }

  get fullName(): string {
    const fullName = `${this.firstName ? this.firstName : ''} ${this.lastName ? this.lastName : ''}`.trim();
    return fullName ? fullName : null;
  }
}
